<template>
  <p style="font-size: 18px">
    Your browser has <b>Razor Wallet</b> enabled, which
    <b>blocks key features</b> on our site.
  </p>
  <p><b>✅ Fix:</b> Turn off Razor Wallet → Refresh page.</p>
  <PButton
    class="p-button-primary w-full relative flex align-items-center justify-content-center mt-4 account-exit"
    @click="handleClose"
  >
    Got it
  </PButton>
</template>

<script lang="ts" setup>
import { inject } from 'vue';

type IProps = {
  visible?: boolean;
};

defineProps<IProps>();
defineEmits(['update:visible']);

const dialogRef = inject('dialogRef');

function handleClose() {
  dialogRef.value.close();
}
</script>

<style lang="scss" scoped>
.send-button {
  width: 100%;
  margin-top: 10px;
}

.step {
  ::v-deep(.p-blockui) {
    opacity: 0;
  }
}
</style>
<style lang="scss" scoped>
.p-dialog-content {
  p {
    margin-top: 0;
    line-height: 1.4;
  }
}

.account-exit {
  font-weight: 500;
  font-size: 17px;
  padding: 15px 24px;
}
</style>
